import { useMutation } from "@tanstack/react-query";
import { SuperBillControllerApi } from "../services";
import { getConfigObject, getXtenantId } from "../utils/utils";


export const useBatchPrintInvoice = () =>
  useMutation({
    mutationFn: async (requestBody: Array<string>) =>
      new SuperBillControllerApi(getConfigObject()).batchPrintInvoices(
        requestBody,
        getXtenantId(),
        { responseType: "blob" }
      ),
  });
